import React from "react";
import { Grid, Text, Badge } from "@mantine/core";
import {
  getClientDisplayName,
  getClientRpqSummary,
} from "../helpers/arFormUtils";
import { useOrderClientRpq } from "../hooks/useOrderClientRpq";

const SummaryItem = ({ label, value }) => (
  <div>
    <Text size="xs" color="dimmed" mb={2}>
      {label}
    </Text>
    <Text size="sm">{value || "—"}</Text>
  </div>
);

const OrderInvestmentClientRpq = ({ form, orderSource }) => {
  const source = orderSource ?? form?.values ?? {};
  const hookRpqSummary = useOrderClientRpq(form || { values: {} }, !orderSource);
  const rpqSummary = orderSource
    ? getClientRpqSummary({
        client: source.client,
        rpq: source.rpq ?? source.client?.rpq,
        rpqStatus: source.rpqStatus ?? source.client?.rpqStatus,
      })
    : hookRpqSummary;

  const clientName = getClientDisplayName(source);

  return (
    <Grid gutter="md">
      <Grid.Col span={6} md={3}>
        <SummaryItem label="Client 客戶" value={clientName} />
      </Grid.Col>
      <Grid.Col span={6} md={3}>
        <SummaryItem
          label="RPQ within last 1 year 一年內"
          value={rpqSummary.withinLastYear ? "Yes 是" : "No 否"}
        />
      </Grid.Col>
      <Grid.Col span={6} md={3}>
        <SummaryItem
          label="RPQ risk profile 風險取向"
          value={
            rpqSummary.riskLabel
              ? `${rpqSummary.riskLevel} – ${rpqSummary.riskLabel}`
              : null
          }
        />
      </Grid.Col>
      <Grid.Col span={6} md={3}>
        <Text size="xs" color="dimmed" mb={2}>
          RPQ status
        </Text>
        <Badge
          size="sm"
          variant="outline"
          color={rpqSummary.status === "VALID" ? "green" : "gray"}
        >
          {rpqSummary.status}
        </Badge>
      </Grid.Col>
    </Grid>
  );
};

export default OrderInvestmentClientRpq;
